import { localizeParam, matchParam } from '$lib/i18n-url';

const localizedParam = localizeParam(1, 'l_facilities', {
	en: 'for-facilities',
	de: 'fuer-haftanstalten'
});

export const match = (param) => matchParam(param, localizedParam);
